import elementUtils from 'utils/elementUtils';
import findElementUtils from 'utils/findElementUtils';
import selectionUtils from 'utils/selectionUtils';

/**
 * @constructor
 */
function SelectLinksCommand() {
}

function getFurthermostTouchingLink(currentLinkElement, shouldGoLeft, editor) {
    var nearestTouchingTextNode = findElementUtils.getTextNodeNextToElement(currentLinkElement, shouldGoLeft, editor);
    if (!nearestTouchingTextNode) {
        return currentLinkElement;
    }

    var containingElement = nearestTouchingTextNode.getParent();
    var nextLink = containingElement.is('a') ? containingElement : elementUtils.getElementFromPath('a', editor.elementPath(containingElement));

    if (nextLink && nextLink.getAttribute('dataquery') === currentLinkElement.getAttribute('dataquery')) {
        return getFurthermostTouchingLink(nextLink, shouldGoLeft, editor);
    }

    return currentLinkElement;
}

SelectLinksCommand.prototype = {
    editorFocus: false,
    /**
     * @param editor
     */
    exec: function (editor) {
        var range = selectionUtils.getSelectedRange(editor);
        var firstInPath = elementUtils.getElementFromPath(range.startPath(), 'a');
        var lastInPath = elementUtils.getElementFromPath(range.endPath(), 'a');

        if (!firstInPath && !lastInPath) {
            return;
        }

        if (firstInPath) {
            range.setStartAt(getFurthermostTouchingLink(firstInPath, true, editor), CKEDITOR.POSITION_AFTER_START);
        }

        if (lastInPath) {
            range.setEndAt(getFurthermostTouchingLink(lastInPath, false, editor), CKEDITOR.POSITION_BEFORE_END);
        }

        range.select();
    }
};

export default SelectLinksCommand;
